import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AddressFields } from "@/components/AddressFields";
import { Spinner } from "@/components/ProtectedRoute";

export default function Profile() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/profile").then(({ data }) => setData({ ...data, country: data.country || "IT" }));
  }, []);

  if (!data) return <Spinner />;

  const save = async () => {
    setSaving(true);
    try {
      const { email, ...body } = data;
      await api.put("/profile", body);
      toast.success("Profilo salvato");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 pt-6 sm:px-6">
      <h1 className="text-3xl font-extrabold tracking-tight">Profilo</h1>
      <p data-testid="profile-email" className="mt-1 text-sm text-muted-foreground">{data.email}</p>
      <section className="card-mc mt-5 p-4">
        <h2 className="mb-3 text-base font-extrabold md:text-lg">Indirizzo di spedizione</h2>
        <p className="mb-4 text-xs text-muted-foreground">Lo troverai già compilato in cassa.</p>
        <AddressFields value={data} onChange={setData} prefix="profile" />
        <button data-testid="profile-save-button" className="btn-mc mt-5 w-full sm:w-auto" disabled={saving} onClick={save}>
          {saving && <Loader2 className="h-4 w-4 animate-spin" />} Salva indirizzo
        </button>
      </section>
    </div>
  );
}
